
import React from 'react'

export default function Container({ children, className, style }) {
  return (
    <div className={className} style={{
      flexWrap: 'wrap',
      maxWidth: '1100px',
      margin: '0 auto',
      paddingLeft: '1.5em',
      paddingRight: '1.5em',
      ...style
    }}>
      {children}
    </div>
  )
}
